module.exports = __webpack_public_path__ + "static/logo-394857a33c6a78b57efed34544bed074.svg";